import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Flex, H1WithBack, PageFooter, PageWrapper, Table, Th, Tr } from 'styling/GlobalStyles'
import { convertToDate, formatNumbersForDisplay, formatDateWithTime, getParams, handlePagination } from 'utils/helpers'
import { clearFuelData, getBatches } from 'features/fuelManagement/fuelManagementSlice'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { FilterEnum, IFilter } from 'components/Filter/SingleFilter'
import { fuelTypes } from './fuelData'
import { endOfWeek, startOfWeek } from 'date-fns'

export const FuelBatches = () => {
    const { batches } = useSelector((store: RootState) => store.fuelManagement)
    const searchParams = new URLSearchParams(window.location.search);
    const [params, setParams] = useState<any>(getParams({
        location, ap: {
            dateFrom: searchParams.get('dateFrom') ? new Date(searchParams.get('dateFrom')) : startOfWeek(new Date(), { weekStartsOn: 1 }),
            dateTo: searchParams.get('dateTo') ? new Date(searchParams.get('dateTo')) : endOfWeek(new Date(), { weekStartsOn: 1 }),
        }
    }))

    useQueryPagination({ fetchFunctions: [getBatches], cleanUpFunctions: [clearFuelData], params })

    const setDateFrom = (value) => {
        setParams(prev => {
            const copy = structuredClone(prev)
            copy.dateFrom = convertToDate(value)
            return copy
        })
    }

    const setDateTo = (value) => {
        setParams(prev => {
            const copy = structuredClone(prev)
            copy.dateTo = convertToDate(value)
            return copy
        })
    }

    const filters: IFilter[] = [
        {
            type: FilterEnum.FIXED_LIST,
            name: 'Fuel Type',
            state: null,
            propName: 'fuelTypeId',
            sd: true,
            single: true,
            filterOptions: fuelTypes.map(s => ({ name: s.label, id: s.value.toString() })),
        },


    ]

    return <>
        <NavBar filterOptions={filters} enableTemporaryManualClosing setParams={setParams} params={params} />
        <PageWrapper>
            <Flex width='100%' between >
                <H1WithBack title='Batches' arrow />

                <Flex gap='1rem'>
                    <CalendarInput
                        maxDate={new Date(params.dateTo)}
                        labelText='Start date'
                        defaultValue={new Date(params.dateFrom || new Date())}
                        onChange={v => setDateFrom(v)}
                    />
                    <CalendarInput
                        minDate={new Date(params.dateFrom)}
                        labelText='End date'
                        defaultValue={new Date(params.dateTo || new Date())}
                        onChange={v => setDateTo(v)}
                    />
                </Flex>
            </Flex>
            {!batches?.data?.length ? (
                <NoItems title='Batches' />
            ) : (
                <Table width='100%' >
                    <Th >
                        <Td w='20%' noTooltip text='TANK' />
                        <Td w='20%' noTooltip text='TYPE' />
                        <Td w='20%' noTooltip text='QUANTITY' />
                        <Td w='20%' noTooltip text='COST' />
                        <Td w='20%' noTooltip text='SUPPLIER' />
                        <Td w='20%' noTooltip text='EMPLOYEE' />
                        <Td w='20%' noTooltip text='DATE' />
                    </Th>
                    {batches?.data.map((b) => {
                        return (
                            <Tr key={b.id}>
                                <Td w='20%' text={b?.fuelTank?.name || '/'} />
                                <Td w='20%' text={b?.fuelType?.name || '/'} />
                                <Td w='20%' text={formatNumbersForDisplay(b?.quantity)} />
                                <Td w='20%' text={b?.cost ? (formatNumbersForDisplay(b.cost) + ' GH₵') : '/'} />
                                <Td w='20%' text={b?.supplier?.name || '/'} />
                                <Td w='20%' text={b?.user ? (b?.user?.firstName + ' ' + b?.user?.lastName) : '/'} />
                                <Td w='20%' text={formatDateWithTime(b.date)} />
                            </Tr>
                        )
                    })}
                </Table>
            )}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(batches?.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}